<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("stock") }} {{ $t("take") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("stock") }} {{ $t("take") }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <!-- <div>
        <router-link
          variant="default"
          class="btn-blue"
          to="/fnb/add-purchase-order"
        >{{ $tc('add') }}</router-link>
      </div>-->
    </div>

    <div
      v-if="selectedCinema != ''"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <div>
        <b-form-input
          @input="searchRmOffline()"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2" v-if="false">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing') }}
          <span>1-20</span>
          {{ $t('of') }}
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  href="#"
                  @click="onSelectCinema(dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
        <!-- STORE -->
        <div class="col-md-2 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedStore.length > 0 ? 'shift-up' : ''">{{
              $tc("store", 1)
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedStore"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Stores"
                  :key="dropdownIndex"
                  href="#"
                  @click="onSelectStore(dropdownItem)"
                  >{{ dropdownItem.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedMaterialCategory.length > 0 ? 'shift-up' : ''"
              >{{ $tc("Category", 1) }}</label
            >

            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedMaterialCategory"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <b-dropdown-item href="#" @click="clearMaterialCategory()">{{
                  "All"
                }}</b-dropdown-item>
                <b-dropdown-item
                  v-for="(dropdownItem,
                  dropdownIndex) in ms_raw_material_categories"
                  :key="dropdownIndex"
                  href="#"
                  @click="onSelectMaterialCategory(dropdownItem)"
                  >{{ dropdownItem.rmc_category }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="col-md-2 mb-3">
          <button class="btn-blue" @click.prevent.stop="onFetch()">
            {{ $t("Fetch") }}
          </button>
        </div>
        <div v-if="selectedCinema.length > 0" class="col-md-2 mb-4">
          <button class="btn-blue" @click.prevent.stop="submitStock()">
            {{ $t("calculate") }} {{ $t("variance") }}
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end ">
        <div
          v-if="purchaseOrders && purchaseOrders.length > 0"
          class="d-flex justify-content-end mb-4 align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="pdfFile"
            :href="BASE_URL + pdfFile"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img
              src="@/assets/img/icons/pdf-icon.svg"
              height="25"
              width="25"
              class="mx-1"
            />
          </a>
          <a
            v-if="excelFile"
            :href="BASE_URL + excelFile"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>

        <div
          v-if="
            selectedCinema.length > 0 && hasEditedOrders
          "
          class="col-md-2 mb-4"
        >
          <button
            class="btn-blue"
            @click.prevent.stop="addAllToPhysicalStock()"
          >
            {{ $t("process") }} {{ $t("all") }}
          </button>
        </div>
      </div>
      <!-- LIST VIEW -->
      <div class="table-scroll">
        <table class="list-view-table text-center" v-if="listView">
          <thead>
            <tr>
              <!-- <th>{{ $t('orderNo') }}</th> -->
              <th class="text-left" style="width:300px;">
                <img
                  v-if="this.columnName != 'rm_name'"
                  @click="onSortValue('rm_name', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('rm_name', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('rm_name', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $tc("rawmaterials", 2) }}
              </th>
              <!-- <th>{{ $t("uom") }}</th> -->
              <!-- <th>{{ $tc('vendor', 1) }}</th> -->

              <!-- <th class="text-left">{{ "category" }} </th> -->
              <th class="text-left">{{ $t("store") }} {{ $t("name") }}</th>
              <th class="text-left">{{ $t("system") }} {{ $t("stock") }}</th>
              <!-- <th class="text-center">
                {{ $t("system") }} {{ $t("stock") }} {{ $t("min_unit") }}
              </th> -->
              <th class="text-left">{{ $t("Remaining") }} {{ $t("stock") }}</th>
              <th class="text-left">{{ $t("unit") }}</th>
              <th class="text-left">{{ $t("physical") }} {{ $t("stock") }}</th>
              <th class="text-center">{{ $t("variance") }}</th>
              <th class="text-center">{{ $t("Reason") }}</th>
              <th class="text-left" colspan="2">
                {{ $t("add") }} {{ $t("remark") }}
              </th>
              <th v-if="false">
                {{ $t("amount") }} / {{ $tc("price", 1) }} {{ $t("of") }}
                {{ $t("wastage") }}
              </th>
              <th>{{ $t("stock") }} {{ $t("Update") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(purchaseOrder, purchaseOrderList) in purchaseOrders"
              :key="purchaseOrderList"
              :class="purchaseOrder.hasOwnProperty('vendorRateAvailable') && purchaseOrder.vendorRateAvailable == 'N' ? 'noVendorRate' : ''"
            >
              <!-- <td>{{ purchaseOrder.po_number ? purchaseOrder.po_number: 'N/A' }}</td> -->
              <td class="text-left " style="width:200px;">
                {{ purchaseOrder.rm_name ? purchaseOrder.rm_name : "N/A" }}
                <br>
                <template v-if="purchaseOrder.hasOwnProperty('vendorRateAvailable') && purchaseOrder.vendorRateAvailable == 'N'">
                 <span class="fs-10">No Rates Found. Please Add Rates in Vendor</span>
              </template>
              </td>
              <td class="text-left">
                {{ purchaseOrder.sm_store_name || "N/A" }}
              </td>
              <td class="text-left">
                {{
                  parseFloat(purchaseOrder.converted_system_stock).toFixed(3)
                }}&nbsp;
                {{
                  purchaseOrder.uom_short_form
                    ? purchaseOrder.uom_short_form
                    : "N/A"
                }}
              </td>
              <!-- <td>{{ purchaseOrder.v_name ? purchaseOrder.v_name : 'N/A' }}</td> -->
              <!-- <td class="text-center">
                {{ purchaseOrder.final_stock_quantity }}&nbsp;{{
                  purchaseOrder.lowest_unit
                }}
              </td> -->

              <td class="text-left">
                <input
                  style="border-radius: 5px"
                  class="w-100 form-control form-control-sm"
                  placeholder
                  type="number"
                  v-model="purchaseOrder.convert_physical_stock"
                  @input="
                    convertPhysicalStock(
                      $event,
                      purchaseOrderList,
                      purchaseOrder
                    )
                  "
                />
              </td>
              <td class="text-left">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container stockUOM-dropdowm">
                    <multiselect
                      v-model="purchaseOrder.uom"
                      :disabled="DISABLE_RAW_MATERIAL_UOM_SWITCH == 'Y'"
                      @select="onSelectUom($event, purchaseOrderList)"
                      placeholder="select"
                      :options="purchaseOrder.UOMARRAY"
                      label="uom_short_form"
                      track-by="uom_id"
                      :multiple="false"
                      select-label="Select"
                      deselect-label=""
                      :allow-empty="false"
                    >
                    </multiselect>
                  </div>
                </div>
              </td>
              <td class="text-left">
                <input
                  disabled
                  style="border-radius: 5px"
                  class="w-100 form-control form-control-sm"
                  placeholder
                  type="number"
                  v-model="purchaseOrder.convert_physical_stock"
                  @input="physicalStockMe(purchaseOrderList, '$event')"
                />
              </td>
              <td
                class="text-center"
                :class="[
                  purchaseOrder.variance < 0
                    ? 'bg-red'
                    : purchaseOrder.variance == 0
                    ? 'bg-transparent'
                    : String(purchaseOrder.variance).includes('-')
                    ? 'bg-red'
                    : 'bg-green',
                ]"
              >
                {{
                  purchaseOrder.variance_converted
                    ? parseFloat(purchaseOrder.variance_converted).toFixed(3)
                    : 0
                }}
              </td>
              <!-- <td
              colspan="2"
              v-if="purchaseOrder.variance ? purchaseOrder.variance == 0 : true"
            ></td> -->
              <td class="text-left">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container reason_multiselect">
                    <!-- @select="onSelectReason($event, purchaseOrderList)" -->
                    <multiselect
                      v-model="purchaseOrder.stockReason"
                      :options="stockReasonData"
                      label="reason_name"
                      track-by="reason_id"
                      :allow-empty="true"
                      :multiple="false"
                      select-label=""
                      placeholder="-"
                      :id="`textarea-${purchaseOrder.rm_id}`"
                    >
                    </multiselect>
                    <p
                      :id="`error_required-${purchaseOrder.rm_id}`"
                      style="color: red"
                      class="mb-0"
                    ></p>
                  </div>
                </div>
              </td>

              <td colspan="2" class="text-left">
                <textarea
                  style="border-radius: 5px"
                  class="w-100 form-control form-control-sm"
                  placeholder
                  type="text"
                  v-model="purchaseOrder.remark"
                ></textarea>
              </td>
              <!-- v-if="
                (purchaseOrder.variance && purchaseOrder.variance >= 0) ||
                purchaseOrder.variance <= 0
              " -->
              <td v-if="false" class="text-right">
                <input
                  style="border-radius: 5px"
                  class="w-100 form-control form-control-sm"
                  placeholder
                  type="number"
                  v-model="purchaseOrder.ps_amount"
                />
              </td>
              <!-- <td v-else></td> -->
              <!-- v-if="
                (purchaseOrder.variance && purchaseOrder.variance >= 0) ||
                purchaseOrder.variance <= 0
              " -->
              <td
                class="px-0"
                v-if="
                  purchaseOrder.isEdited 
                "
              >
                <button
                  class="btn-blue mx-0 p-0"
                  :disabled="!purchaseOrder.isEdited"
                  @click.prevent.stop="addWastage(purchaseOrder)"
                >
                  {{ $t("Update") }}
                </button>
              </td>
              <td v-else></td>
            </tr>
            <tr v-if="purchaseOrders.length == 0">
              <td colspan="12">
                <!-- <h6 class="ml-3">
                No Records Found
                <br />
                <span v-if="selectedCinema.length == 0"
                  ><h6 class="ml-3">Please select cinema.</h6></span
                >
              </h6> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(purchaseOrder, purchaseOrderkey) in purchaseOrders"
        :key="purchaseOrderkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>
              {{ purchaseOrder.po_number ? purchaseOrder.po_number : "N/A" }}
            </h6>
            <h6>{{ purchaseOrder.rm_name ? purchaseOrder.rm_name : "N/A" }}</h6>
            <h6>{{ purchaseOrder.v_name ? purchaseOrder.v_name : "N/A" }}</h6>
            <h6>
              {{ purchaseOrder.final_stock_quantity }}
            </h6>
            <h6>
              {{
                purchaseOrder.uom_short_form
                  ? purchaseOrder.uom_short_form
                  : "N/A"
              }}
            </h6>
            <!-- <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item @click="goToRoute('/fnb/edit-stock-in',purchaseOrder)">
                  <span class="edit-pen mr-1"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-stock-in',purchaseOrder)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>-->
          </div>

          <!-- <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import _ from "lodash";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import ExhibitorService from "@/services/ExhibitorService";
  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        isEdited: false,
        isVarienceEdited : false,
        btnDisbaled: false,
        CinemasCopy: [],
        searchCinema: "",
        isRoleID: true,
        isRoleID1: null,
        getitem: "",
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        selectedid: "",
        selectedStoreId: null,
        ms_raw_material_categories: [],
        stockReasonData: [],
        selectedMaterialCategory: "",
        gridView: false,
        listView: true,
        purchaseOrders: [],
        rmCopy: [],
        stock_in_id: "",
        stock_in_details: {},
        UomList: [],
        groupUomList: [],
        Cinemas: [],
        Stores: [],
        selectedCinema: "",
        selectedStore: "",
        selectedUom: "",
        stock_quantity: "",
        stock_in_quantity: 0,
        selectedMaterialCatgeoryId: "",
        selectedReason: "",
        excelFile: "",
        pdfFile: "",
        selectedCinemaObject: {},

        debounce: null,
        searchValue: "",

        //sorting
        isSort: false,
        isAscending: false,
        columnName: "",
        orderBy: "",
      };
    },
    computed: {
      DISABLE_RAW_MATERIAL_UOM_SWITCH() {
        return this.$store.getters.DISABLE_RAW_MATERIAL_UOM_SWITCH || 'N';
      },
      isVariance() {
        let array = this.purchaseOrders.filter((x) => {
          //console.log("x :>> ", x);
          return x.variance && x.variance != 0;
        });
        return array;
      },
      hasEditedOrders() {
    return this.purchaseOrders.some((order) => order.isEdited);
  }
    },

    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.isRoleID1 = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
        this.getCinemas(obj);
      } else {
        this.getCinemas(obj);
      }
      this.getviewingnumber();
      this.getRawMaterialCategories();
      this.getStockReasonData();
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.selectedCinema = CinemaObj.cine_name;
        this.selectedid = CinemaObj.cine_id;
        this.getStoreLevels(CinemaObj.cine_id);
      };
   
    },
    
    methods: {
      check: function() {
        // if (this.purchaseOrder.remark == "") {
        //   this.purchaseOrder.remark = "Please enter text in text box below";
        // }
        if (
          this.purchaseOrders &&
          !this.purchaseOrders.hasOwnProperty("stockReason")
        ) {
          let Reason = this.purchaseOrder.stockReason;
          Reason.reason_name = "Please Select A Reason From The Dropdown";
        }
      },
      createUOMArray(UOMID) {
        let tempArray = [];
        let tempArray2 = [];
        tempArray = this.UomList.filter((x) => x.conversion_from == UOMID);
        if (tempArray.length > 0) {
          tempArray2 = this.UomList.filter(
            (x) => x.conversion_to == tempArray[0].conversion_to
          );
        } else {
          tempArray2 = this.UomList.filter((x) => x.uom_id == UOMID);
        }
        //console.log("tempArray2", tempArray2);
        return tempArray2;
      },
      ConvertToTheLowestUnit(UOMID) {
        let tempArray = [];
        let tempArray2 = [];
        let unit = "";
        tempArray = this.UomList.filter((x) => x.uom_id == UOMID);
        if (tempArray.length > 0) {
          tempArray2 = this.UomList.filter(
            (x) => x.uom_id == tempArray[0].conversion_to
          );
        }
        if (tempArray2.length > 0 && tempArray.length > 0) {
          unit = tempArray2[0].uom_short_form;
        } else {
          unit = tempArray[0].uom_short_form;
        }
        return unit;
      },
      onSelectUom(event, index) {
        this.purchaseOrders[index].uom = event;
        let uomID = event.uom_id;
        let value = this.purchaseOrders[index].physical_stock;
        this.purchaseOrders[
          index
        ].convert_physical_stock = this.convertStockUOM(value, uomID);
        this.$forceUpdate();
      },
      convertPhysicalStock(event, index, purchaseOrder) {
        let value = event.target.value;
        let UOMID = purchaseOrder.uom.uom_id;
        let [UOM] = this.UomList.filter((x) => x.uom_id == UOMID);
        let conversionFormula = UOM.conversion_formula || 1;
        let convertedValue = value * conversionFormula;
        this.purchaseOrders[index].physical_stock = Math.round(convertedValue);
        this.purchaseOrders[index].isEdited = true;
        this.physicalStockMe(index, null);
      },
      convertStockUOM(value, UOMID) {
        let [UOM] = this.UomList.filter((x) => x.uom_id == UOMID);
        let conversionFormula = UOM.conversion_formula || 1;
        let convertedValue = value / conversionFormula;
        return convertedValue;
      },
      physicalStockMe(index, event) {
        console.log(index, event, this.purchaseOrders[index].physical_stock);
        if (parseInt(this.purchaseOrders[index].physical_stock) < 0) {
          this.purchaseOrders[index].physical_stock = 0;
          this.purchaseOrders[index].convert_physical_stock = 0;
          this.$toasted.show("Physical Stock Cannot be less than zero");
        }

        this.purchaseOrders[index].isEdited = true;
        
        console.log(" this.isEdited",  this.purchaseOrders[index].isEdited)

        this.submitStock();
        this.$forceUpdate();
      },
      onFetch: function() {
        this.getPurchaseOrderList(this.selectedid);
      },
      onSelectMaterialCategory: function(params) {
        this.selectedMaterialCatgeoryId = params.rmc_id;
        this.selectedMaterialCategory = params.rmc_category;
      },

      clearMaterialCategory: function() {
        this.selectedMaterialCatgeoryId = "";
        this.selectedMaterialCategory = "";
      },
      // onSelectReason: function(event) {
      //   this.selectedReason = event.reason_name;
      // },
      getCinemas: function(cine_id) {
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.selectedCinema = x.cine_name;
                  // this.getitem = x.cine_id;
                  // // console.log("this.getitem :", this.getitem);
                  // this.getPurchaseOrderList(this.getitem);
                  this.onSelectCinema(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectCinema: function(params) {
        // this.stock_in_details["cinema_id"] = params.cine_id;
        this.selectedCinema = params.cine_name;
        this.selectedid = params.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
        this.getStoreLevels(params.cine_id);
        this.$store.dispatch("selectDropdownCinema", params);
      },
      getStoreLevels: function(cinema_id) {
        this.Stores = [];
        this.selectedStore = "";
        // let payload = {
        //   tableName: "store_management",
        //   sm_is_active: "Y",
        //   cinema_id: cinema_id
        // };
        MasterService.GetStoreManagement({ cine_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Stores = data.Records;
              // this.getPurchaseOrderList(cinema_id);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getPurchaseOrderList: function(cinema_id, stock = null) {
        let rm_id = null;

        if (stock) {
          rm_id =
            stock.hasOwnProperty("rm_id") && stock.rm_id ? stock.rm_id : null;
        }

        if (!stock) {
          this.purchaseOrders = [];
        }
        let loader = this.$loading.show();
        let sm_id = this.selectedStoreId;
        let payload = {
          sm_id: this.selectedStoreId,
          cinema_id: this.selectedid,
          cinema_name: this.selectedCinema,
          searchValue: this.searchValue,
          columnName: this.columnName,
          orderBy: this.orderBy,
          rm_id: rm_id || null,
          rmc_id: this.selectedMaterialCatgeoryId || null,
        };
        PosFnbService.GetAllStock(payload)
          .then((response) => {
            const { data } = response;

       
            if (data && data.status && data.Records.length > 0) {
              // this.purchaseOrders = data.Records.filter((x) => {
              //   return x.final_stock_quantity > 0;
              // });
              if (rm_id) {
                let findIndex = this.purchaseOrders.findIndex(
                  (x) => x.rm_id == rm_id
                );
                if (findIndex > -1) {
                  console.log("-1 working");
                  let updatedArray = data.Records.map((x) => {
                    x["physical_stock"] = x.final_stock_quantity;
                    x["remark"] = "";
                    x["ps_amount"] = "0";
                    x["variance"] = 0;
                    x["variance_converted"] = 0;
                    x["uom"] = {
                      uom_id: x.uom_id,
                      uom_description: x.uom_description,
                      uom_short_form: x.uom_short_form,
                    };
                    x["convert_physical_stock"] = parseFloat(
                      this.convertStockUOM(x.final_stock_quantity, x.uom_id) ||
                        0
                    ).toFixed(3);
                    x["converted_system_stock"] = parseFloat(
                      this.convertStockUOM(x.final_stock_quantity, x.uom_id) ||
                        0
                    ).toFixed(3);
                    x["UOMARRAY"] = this.createUOMArray(x.uom_id);
                    x["lowest_unit"] = this.ConvertToTheLowestUnit(x.uom_id);
                    // x["stockReason"] = {};
                    x["isEdited"] = false;
                   
                    return x;
                  });
                  if (updatedArray && updatedArray.length > 0) {
                    this.purchaseOrders[findIndex] = _.cloneDeep(
                      updatedArray[0]
                    );
                  }
                  this.$forceUpdate();
                }
              } else {
                console.log("-1 else working");
                this.purchaseOrders = data.Records;
                this.excelFile = data.FinalExcelFile;
                this.pdfFile = data.FinalPDFFile;
                this.UomList = data.UOMs;
                this.purchaseOrders = this.purchaseOrders.map((x) => {
                  x["physical_stock"] = x.final_stock_quantity;
                  x["remark"] = "";
                  x["ps_amount"] = "0";
                  x["variance"] = 0;
                  x["variance_converted"] = 0;
                  x["uom"] = {
                    uom_id: x.uom_id,
                    uom_description: x.uom_description,
                    uom_short_form: x.uom_short_form,
                  };
                  x["convert_physical_stock"] = parseFloat(
                    this.convertStockUOM(x.final_stock_quantity, x.uom_id) || 0
                  ).toFixed(3);
                  x["converted_system_stock"] = parseFloat(
                    this.convertStockUOM(x.final_stock_quantity, x.uom_id) || 0
                  ).toFixed(3);
                  x["UOMARRAY"] = this.createUOMArray(x.uom_id);
                  x["lowest_unit"] = this.ConvertToTheLowestUnit(x.uom_id);
                  // x["stockReason"] = {};
                  x["isEdited"] = false;
                  return x;
                });
              }

              this.rmCopy = _.cloneDeep(this.purchaseOrders);
              // if (data.totalRows >= 10) {
              //   this.rows = data.totalRows;
              // } else {
              //   this.rows = data.totalRows;
              //   this.selectedvalue = data.totalRows;
              // }
              // console.log("Records :", data.Records);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            loader.hide();
          });
      },
      getStockReasonData() {
        let payload = {
          reason_is_active: "Y",
        };
        ExhibitorService.GetStockReasonData(payload)
          .then((response) => {
            const { data } = response;

            if (data.Records.length > 0) {
              // console.log(data.Records);
              this.stockReasonData = data.Records;
            } else {
              this.stockReasonData = [];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      getRawMaterialCategories: function() {
        this.ms_raw_material_categories = [];
        let payload = {
          filter_is_active: "Y",
        };
        PosFnbService.GetRawMaterialCategories(payload)
          .then((response) => {
            const { data } = response;
            //console.log("data.message :", data.message);
            if (data && data.status && data.Records.length > 0) {
              this.ms_raw_material_categories = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show("No Records Found");
            }
          })
          .catch(this._CatchError); //message
      },
      onSelectStore: function(item) {
        this.selectedStore = item.sm_store_name;
        this.selectedStoreId = item.sm_id;
        //   this.getPurchaseOrderList();
      },
      onSortValue(columnName, orderBy) {
        if (this.selectedid.length == 0) {
          return this.$toasted.show("Please select cinema");
        }
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getPurchaseOrderList(this.selectedid);
      },
      onSearch: function() {
        this.getPurchaseOrderList(this.selectedid);
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      submitStock: function() {
        this.purchaseOrders = this.purchaseOrders.map((x) => {
          x["variance"] =
            x.physical_stock || x.physical_stock == 0
              ? x.physical_stock - x.final_stock_quantity
              : 0;
          x["variance_converted"] = this.convertStockUOM(x.variance, x.uom_id);
          return x;
        });
      },
      // validation: function(id = 0) {
      //   let textarea = document.getElementById(`textarea-${id}`).value;
      //   let error_required = document.getElementById(`error_required-${id}`);

      //   //  let error_content = error_required.textContent="Error";
      //   if (textarea.length == 0) {
      //     error_required.textContent = "Required";
      //     setTimeout(() => {
      //       error_required.textContent = "";
      //     }, 3000);
      //     return false;
      //   } else {
      //     error_required.textContent = "";
      //     return false;
      //   }
      // },
      validation: function(id = 0) {
        // let textarea = document.getElementById(`textarea-${id}`).value;
        let isStockReasonRequired =
          this.purchaseOrders &&
          this.purchaseOrders.hasOwnProperty("stockReason");
        console.log(isStockReasonRequired, "isStockReasonRequired");
        let error_required = document.getElementById(`error_required-${id}`);

        //  let error_content = error_required.textContent="Error";
        if (!isStockReasonRequired) {
          error_required.textContent = "Required";
          setTimeout(() => {
            error_required.textContent = "";
          }, 3000);
          return false;
        } else {
          error_required.textContent = "";
          return false;
        }
      },
      addWastage: function(stock) {
        // if (stock.variance != 0 && stock.remark.length == 0) {
        //   this.$toasted.show("Please Provide a remark");
        //   this.validation(stock.rm_id);
        //   return;
        // }
        if ( !stock.hasOwnProperty("stockReason")) {
          this.$toasted.show("Please Provide a Reason");
          this.validation(stock.rm_id);
          return;
        }
        if (
          false
          // (textarea.length == 0 &&
          //   stock.variance == 0 &&
          //   stock.remark.length == 0) ||
          // (stock.variance != 0 && stock.remark.length == 0)
        ) {
          return (
            this.$toasted.show("Please Provide a remark") && this.validation()
          );
        } else if (
          (stock.ps_amount.length == 0) ||
          (stock.ps_amount.length == 0)
        ) {
          return this.$toasted.show(
            "Please Provide a Sales Price / Price of wastage"
          );
        } else {
          this.btnDisbaled = true;
          let payload = {
            physicalStocks: [stock],
          };
          let loader = this.$loading.show();
          PosFnbService.AddAllPhysicalStock(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
                this.$nextTick(() => {
                  this.getPurchaseOrderList(null, stock);
                });
              } else {
                this.$toasted.show(data.message);
              }
              
            })
            .catch((error) => {
              this.$toasted.show(error);
            })
            .finally(() => {
              this.btnDisbaled = false;
              loader.hide();
            });
        }
      },
      addAllToPhysicalStock: function() {
        let physicalStocks = this.purchaseOrders.map((x) => {
          return x ;
        });
        if (physicalStocks && physicalStocks.length > 0) {
          // for (let i = 0; i < physicalStocks.length; i++) {
          //     if (
          //         // (
          //         //   stockObj.variance == 0 &&
          //         //   stockObj.remark.length == 0) ||
          //         physicalStocks[i].variance != 0 && physicalStocks[i].remark.length == 0
          //     ) {
          //         console.log(physicalStocks[i].variance, physicalStocks[i].remark.length)
          //         this.$toasted.show("Please Provide a remark")
          //         this.validation()
          //         return;
          //     }
          // }
          let checkEmptyRemarks = physicalStocks.filter((stockObj) => {
            return stockObj.variance != 0 && stockObj.remark.length == 0;
          });
          let checkEmptyReason = physicalStocks.filter((stockObj) => {
            return (
              stockObj.variance != 0 && !stockObj.hasOwnProperty("stockReason")
            );
          });
          if (checkEmptyReason.length) {
            checkEmptyReason.forEach((remarksObj) => {
              this.validation(remarksObj.rm_id);
            });
            return this.$toasted.show("Please add Reason");
          }
          // if (checkEmptyRemarks.length) {
          //   checkEmptyRemarks.forEach((remarksObj) => {
          //     this.validation(remarksObj.rm_id);
          //   });
          //   return this.$toasted.show("Please add remarks");
          // }
          let array = physicalStocks.filter((x) => {
            return x.ps_amount.length == 0;
          });
          if (array && array.length == 0) {
            let loader = this.$loading.show();
            PosFnbService.AddAllPhysicalStock({ physicalStocks })
              .then((response) => {
                const { data } = response;
                if (data.status) {
                  this.$toasted.show(data.message);
                  this.$nextTick(() => {
                    this.getPurchaseOrderList(this.selectedid);
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.$toasted.show(err);
              })
              .finally(() => {
                loader.hide();
              });
          } else {
            this.$toasted.show(
              "Please provide remark and Sales Price / Price of wastage"
            );
          }
        } else {
          this.$toasted.show("Please add atleast 1 physical stock");
        }
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      goToRoute: function(path, { stock_in_id }) {
        this.$router.push({
          path: path,
          query: {
            stock_in_id: stock_in_id,
          },
        });
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      searchRmOffline(event, type) {
        if (this.searchValue && this.searchValue.length > 0) {
          this.purchaseOrders = this.rmCopy.filter((x) => {
            if (
              x.rm_name &&
              x.rm_name.toLowerCase().includes(this.searchValue.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.purchaseOrders = this.rmCopy;
        }
      },
      onClose: function() {
        this.$refs.updateStock.hide();
      },
      OnFinalSubmit: function() {
        let payload = {
          ...this.stock_in_details,
          stock_in_id: this.stock_in_id,
          stock_quantity: this.stock_quantity,
        };
        PosFnbService.updatStockDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.$refs.updateStock.hide();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          console.log("this.selectedid :", this.selectedid);
          this.getPurchaseOrderList(this.selectedid);
        } else if (this.isRoleID1 == 1 || this.isRoleID1 == 2) {
          this.currentPage = event;
          this.getPurchaseOrderList(this.selectedid);
        } else {
          this.currentPage = event;
          this.getPurchaseOrderList(this.getitem);
        }
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.onChangePagination();
        }
      },
    },
  };
</script>

<style>
  .stockUOM-dropdowm .multiselect__content-wrapper {
    width: 160px !important;
  }

  .reason_multiselect .multiselect__content-wrapper {
    width: 200px !important;
  }
  .table-wrapper {
    /* overflow-x: scroll !important; */
  }

  .table-wrapper .list-view-table {
    /* width: auto!important; */
    table-layout: auto;
    /* white-space: nowrap; */
  }

  .table-wrapper .list-view-table th {
    padding: 5px 10px 5px 10px;
  }

  .bg-red {
    color: red;
    background-color: transparent !important;
  }

  .bg-green {
    color: green;
  }

  .bg-transparent {
    background-color: transparent !important;
    color: black !important;
  }

  .noVendorRate {
    opacity: 0.5;
    color: red;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/stock.vue